<template>
  <article class="rounded-[2.4rem] border border-black/10 bg-white p-5 shadow-sm space-y-3">
    <div class="space-y-2">
      <div
        v-for="sale in saleCards"
        :key="sale.id"
        class="flex items-start justify-between gap-3 rounded-[1.4rem] border border-black/10 bg-black/[0.02] p-3"
      >
        <div class="flex items-start gap-3 flex-1 min-w-0">
          <div class="h-12 w-12 rounded-full overflow-hidden bg-black/5">
            <DoctorImage
              :image="sale.avatar || ''"
              :name="sale.doctorName || ''"
              size="100%"
            />
          </div>
          <div class="flex-1 min-w-0 space-y-1">
            <p
              v-if="sale.typeLabel || sale.modeLabel"
              class="m-0 text-[0.95rem] font-semibold uppercase tracking-wide text-black/50"
            >
              <span v-if="sale.typeLabel">{{ sale.typeLabel }}</span>
              <span v-if="sale.typeLabel && sale.modeLabel"> - </span>
              <span v-if="sale.modeLabel">{{ sale.modeLabel }}</span>
            </p>
            <p class="m-0 text-[1.3rem] font-semibold text-black truncate">
              {{ sale.service }}
            </p>
            <p v-if="sale.doctorName || sale.tenant" class="m-0 text-[1.1rem] text-[color:var(--gray)] truncate">
              <span v-if="sale.doctorName">{{ sale.doctorName }}</span>
              <span v-if="sale.doctorName && sale.tenant"> • </span>
              <span v-if="sale.tenant">{{ sale.tenant }}</span>
            </p>
            <p v-if="sale.date || sale.duration" class="m-0 text-[1.1rem] text-[color:var(--gray)]">
              <span v-if="sale.date">{{ sale.date }}</span>
              <span v-if="sale.date && sale.duration"> • </span>
              <span v-if="sale.duration">{{ sale.duration }}</span>
            </p>
          </div>
        </div>
        <div class="text-right whitespace-nowrap">
          <p class="m-0 text-[1.2rem] font-semibold text-black">{{ sale.pendingLabel }}</p>
          <p v-if="sale.depositLabel" class="m-0 text-[1.05rem] text-[color:var(--gray)]">
            {{ $t('Deposit today: {amount}', { amount: sale.depositLabel }) }}
          </p>
          <button
            type="button"
            class="mt-1 text-[1.1rem] text-red-600 underline"
            @click="$emit('remove-sale', sale.saleId)"
          >
            {{ $t('Remove') }}
          </button>
        </div>
      </div>
    </div>
    <p
      v-if="promoApplied && promoDiscount"
      class="text-[1.2rem] text-[color:var(--gray)]"
    >
      {{ $t('Discount applied') }}: -{{ formatValue(promoDiscount) }}
    </p>
  </article>
</template>

<script>
import DoctorImage from '@/components/doctor/doctorImage.vue';

export default {
  name: 'CheckoutSummaryPanel',
  components: {
    DoctorImage,
  },
  props: {
    saleCards: {
      type: Array,
      default: () => [],
    },
    totalDue: {
      type: Number,
      default: 0,
    },
    promoApplied: {
      type: Boolean,
      default: false,
    },
    promoDiscount: {
      type: Number,
      default: 0,
    },
    formatAmount: {
      type: Function,
      default: null,
    },
  },
  emits: ['remove-sale'],
  methods: {
    formatValue(value) {
      if (typeof this.formatAmount === 'function') {
        return this.formatAmount(value);
      }
      return value === undefined || value === null ? '-' : String(value);
    },
  },
};
</script>
